"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var overStyle = {
  position: 'relative',
  overflow: 'initial',
  top: 'unset',
  left: 'unset',
  zIndex: 'unset'
};
var defaultClx = 'roo-dropdown-menu roo-drop-menu';

var DropMenuList = function DropMenuList(props) {
  return /*#__PURE__*/React.createElement("ul", (0, _assign.default)({}, props, {
    className: (0, _classnames.default)(defaultClx, props.className),
    style: overStyle
  }));
};

var _default = DropMenuList;
exports.default = _default;